import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=488f5439&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"
import style0 from "#/styles/views/HomePage/HomePage.less?vue&type=style&index=0&id=488f5439&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488f5439",
  null
  
)

export default component.exports